module.exports = __webpack_public_path__ + "img/玉溪市妇幼保健院.ee900906.png";